import { AlertTriangle, RefreshCw } from 'lucide-react';

interface QueryErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export default function QueryErrorState({
  message = 'Impossible de charger les données.',
  onRetry,
}: QueryErrorStateProps) {
  return (
    <div className='flex flex-col items-center justify-center gap-4 rounded-xl border border-red-200 bg-red-50/50 px-6 py-16 text-center'>
      <div className='flex h-12 w-12 items-center justify-center rounded-full bg-red-100'>
        <AlertTriangle className='h-6 w-6 text-red-600' />
      </div>
      <div className='space-y-1'>
        <p className='text-sm font-semibold text-slate-800'>Erreur de chargement</p>
        <p className='max-w-sm text-sm text-slate-500'>{message}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className='flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50'
        >
          <RefreshCw className='h-4 w-4' />
          Réessayer
        </button>
      )}
    </div>
  );
}
